var MDB = window.MDB || {};

MDB.Ace = {
    availableThemes: [
        "ambiance","chaos","chrome","clouds","clouds_midnight","cobalt","crimson_editor","dawn","dreamweaver","eclipse","github","idle_fingers","iplastic","katzenmilch","kuroir","merbivore","merbivore_soft","monokai","mono_industrial","pastel_on_dark","solarized_dark","solarized_light","sqlserver","terminal","textmate","tomorrow","tomorrow_night","tomorrow_night_blue","tomorrow_night_bright","tomorrow_night_eighties","twilight","vibrant_ink","xcode"
    ],

    initDefault: function(cssSelector) {
        cssSelector = cssSelector || '.ace-editor';
        $(cssSelector).each(function() {
	        var editor = $(this),
                targetSelector = editor.data('target-selector'),
                target = $(targetSelector);

	        target.hide();

	        var aceEditor = ace.edit(editor.attr('id'));
	        var session = aceEditor.getSession();

	        //window.aceEditor = aceEditor;

	        aceEditor.setOptions({
	            maxLines: Infinity,
	            minLines: 5
	        });

	        session.setValue(target.val());
	        session.on('change', function () {
	            target.val(session.getValue());
	        });

	        var theme = editor.data('theme');
	        if (theme) {
                aceEditor.setTheme(theme);
            }

	        var language = editor.data('language');
	        if (language) {
                session.setMode(language);
            }
	        
	        if(target.attr('readonly')){
				aceEditor.setReadOnly(true);
			}
	    });
    },

    /**
	 * @param config - configuration object: 
	 *          editorElement: css selector or dom object for the editor area
	 *          sourceElement: css selector or dom object where the value from the editor should be stored
	 *                         we'll also listen to events on this object to update the ace editor so it can be a two way sync
	 *          minLines     : The minimum amount of lines used in the editor
	 *          initialValue : Optional initial value to set in the ace editor
	 *          onAceChanged : Optional function that gets called when the value of the ace editor changes
	 *          
	 *			themeSelect  : Optional a select element that will be filled with all available themes
	 *          rememberThemeKey: Optional bool/string if you want to store/restore the theme using localStorage (editor must have a proper id value for this)
	 *                                  when a string is used it will be added to the localstorage key.
	 *        @event   
	 *
	 */
    initEditor:function(config) {

        var editorSelector = $(config.editorElement),
            sourceSelector = $(config.sourceElement);
        // aceEditor


        editorSelector.each(function() {
	        var editor = $(this),
	        	editorId = editor.prop('id');
	        if(!editorId) {
	        	editorId='ace-editor-' + parseInt(Math.random() * 1000000, 10);
	        	// editorId='ace-editor-' + config.rememberThemeKey
		        editor.attr('id', editorId='ace-editor-' + parseInt(Math.random() * 1000000, 10));
		        // 
		        config.rememberThemeKey = false;
		    }

	        if(config.rememberThemeKey) {
	        	// if(config.rememberThemeKey)
	        	var storedTheme = localStorage["ace_theme_" +config.rememberThemeKey + '' +editorId];
	        	if(storedTheme) {
                    editor.data('theme', storedTheme);
                }
	        }


            var aceEditor = ace.edit(editorId);
	        var session = aceEditor.getSession();


	        aceEditor.setOptions({
	            maxLines: Infinity,
	            minLines: config.minLines || 50
	        });
	        if(config.initialValue) {
                session.setValue(config.initialValue);
            }
	        //session.setValue(target.val());
	        session.on('change', function () {
	        	var value = session.getValue();
	        	if(typeof(config.onAceChanged) === 'function') {
                    config.onAceChanged(aceEditor, value);
                }
	        	editor.trigger('ace-value-changed', value);

	            //target.val(session.getValue());
	        });

	        var theme = editor.data('theme');
	        if (theme){
	        	if(theme.indexOf('ace/theme/') !== 0) {
                    theme = 'ace/theme/' + theme;
                }
	            aceEditor.setTheme(theme);
	        }

	        var language = editor.data('language');
	        if (language) {
	        	if(language.indexOf('ace/mode/') !== 0) {
                    language = 'ace/mode/' + language;
                }
	            session.setMode(language);
	        }

	        if(typeof(config.init) === 'function') {
                config.init(aceEditor); 
            }

	        //window._nxtace = aceEditor;
	        if(config.themeSelect) {
	        	var select = $(config.themeSelect).find('option').remove().end();
	        	$('<option value="" />').text('Theme').appendTo(select);
	        	MDB.Ace.availableThemes.forEach(function(themeName, i) {
	        		var value = themeName;
	        		if(value.indexOf('ace/theme/') == -1) {
                        value = 'ace/theme/' + value;
                    }
	        		$('<option />', { value: value }).text(themeName || '').appendTo(select);
	        	});


	        	if(theme) {
                    select.val(theme);
                }
	        	select.on('change', function(e) {
	        		if(this.value) {
	        			aceEditor.setTheme(this.value || '');
	        			localStorage["ace_theme_"+ config.rememberThemeKey + '' +editorId] = this.value || '';
	        		}
	        	});
	        }


        }); 
    }
};